"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Collection = void 0;
var Collection = (function () {
    function Collection(processor) {
        this._processor = processor;
    }
    Object.defineProperty(Collection.prototype, "count", {
        get: function () {
            return this._getCoreItems().length;
        },
        enumerable: false,
        configurable: true
    });
    Collection.prototype.getByIndex = function (index) {
        var obj = this._getCoreItems()[index];
        return obj !== undefined ? this._getItem(obj) : null;
    };
    return Collection;
}());
exports.Collection = Collection;
